import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
} from "../../../shared/routes/auth.routes";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_CREATE_STAFF, API_CREATE_STAFF_SALARY_INFO, API_DELETE_STAFF, API_GET_ALL_STAFF_LIST, API_GET_ALL_VENDOR_LIST, API_GET_STAFF_LIST, API_GET_STAFF_SALARY_INFO, API_STAFF_BULK_IMPORT, API_UPDATE_STAFF, API_UPDATE_STAFF_SALARY_INFO } from "../../../shared/routes/private.routes";

const config = {
  name: "staff",
};
export const getStaffList: any = createAsyncThunk(
  `${config.name}/getStaffList`,
  async ({params, body}: any) => {
    const result = await Client.post(API_GET_STAFF_LIST, body, {params});
    return result?.data
  }
);

export const createStaff: any = createAsyncThunk(
  `${config.name}/create-staff`,
  async (formData: FormData) => {
    return Client.post(API_CREATE_STAFF, formData);
  }
);

export const staffBulkImport: any = createAsyncThunk(
  `${config.name}/staff-bulk-import`,
  async (file: any) => {
    return Client.post(API_STAFF_BULK_IMPORT, file);
  }
);

export const deleteStaff: any = createAsyncThunk(
  `${config.name}/delete-staff`,
  async (staffId: string) => {
    return Client.delete(API_DELETE_STAFF+`${staffId}`);
  }
);

export const updateStaffById: any = createAsyncThunk(
  `${config.name}/update-staff`,
  async ({ staffId, formData }: { staffId: string, formData: FormData }) => {
    const url = API_UPDATE_STAFF + `${staffId}`;
    return Client.put(url, formData
    //   , 
    //   {
    //   // headers: {
    //   //   'Content-Type': 'multipart/form-data',
    //   // },
    // }
  );
  }
);

export const getAllStaffList: any = createAsyncThunk(
  `${config.name}/get-staff-list`,
  async () => {
    return Client.get(API_GET_ALL_STAFF_LIST);
  }
);

export const createStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/create-staff-salary`,
  async (body: any) => {
    const result = await Client.post(API_CREATE_STAFF_SALARY_INFO ,body);
    return result?.data;
  }
);

export const getStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/get-staff-salary`,
  async (staffId: string) => {
    const result = await Client.get(API_GET_STAFF_SALARY_INFO + `${staffId}`);
    return result?.data;
  }
);

export const updateStaffSalaryInfo: any = createAsyncThunk(
  `${config.name}/update-staff-salary`,
  async ({id,body} :{id: string, body:any}) => {
    const url = API_UPDATE_STAFF_SALARY_INFO + `${id}`;
    const result = await Client.put(url ,body);
    return result?.data;
  }
);

export const staffReducer = createSlice({
  name: config.name,
  initialState: {
    loadingStaff: false as any,
    staffList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetStaff: (state) => {
      state.loadingStaff = false;
      state.staffList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
    .addCase(getStaffList.pending, (state) => {
      state.loadingStaff = true;
      state.staffList = [] as any;
    })
    .addCase(getStaffList.fulfilled, (state, action) => {
      state.loadingStaff = false;
      state.staffList = action?.payload?.data as any;
      state.pagination = {page: action?.payload?.page, limit: action?.payload?.limit, total: action?.payload?.total}
    })
    .addCase(getStaffList.rejected, (state) => {
      state.loadingStaff = false;
      state.staffList = [] as any;
    })
  },
});

export const { resetStaff } = staffReducer.actions;
export default staffReducer.reducer;

